module.exports = {"title":"Pin","selectGolfClubPlaceholder":"Select a golf club.","selectTypePlaceholder":"Select a type.","realTimePinPosition":"Real-Time Pin Position","periodPinPosition":"Pin Position History","months":"{n} Month | {n} Months","flag":"Flag","totalCount":"Total {n}","pin":"Pin","date":"Date","time":"Time","duration":"Duration","noData":"No data available."}


//////////////////
// WEBPACK FOOTER
// ./src/locales/en/gr302.json
// module id = Rznz
// module chunks = 2